import { Transform } from 'class-transformer';

/**
 * Trims surrounding whitespace and turns blank strings into `null`, so a form
 * can clear an optional text column by submitting it empty (unlike
 * `OptionalTrimmedStringTransform`, which yields `undefined` = "leave as is").
 */
export function NullableTrimmedStringTransform(): PropertyDecorator {
  return Transform(({ value }) => {
    if (typeof value !== 'string') {
      return value;
    }
    const trimmed = value.trim();
    return trimmed === '' ? null : trimmed;
  });
}
